import {Fragment, useEffect} from 'react';
import {attributeHelpCenterClick, prefetchHelpCenterIdentity} from '../../utils/HelpCenterAttribution';

// SupportMessageText — el texto de un mensaje del chat de soporte.
//
// El cuerpo es texto plano (React lo escapa). Lo único que se vuelve link son las URLs del Centro
// de Ayuda (ayuda.dashbo.io), que el equipo incluye en sus respuestas: el resto sigue como texto,
// así que un mensaje no puede meter links a cualquier lado. Al hacer clic, el link se atribuye al
// chat de soporte (`hc_from=support_chat`) y a quien lo abre, como `LinkToArticle`.

export const SUPPORT_CHAT_SOURCE = 'support_chat';

// Sólo https (el link lleva el token de atribución: por http viajaría en claro). El lookahead
// corta un host que sólo EMPIEZA con ayuda.dashbo.io (`ayuda.dashbo.io.otro.com`, `…io@otro`).
const HELP_LINK_RE = /https:\/\/ayuda\.dashbo\.io(?!\.?[\w@:-])(?:\/[^\s<>"«»]*)?/g;
// Puntuación que cierra la frase y no es parte de la URL: «mira https://…/articles/12-x.»
// Si quedara pegada, el sitio redirige al slug canónico y se pierde la atribución.
const TRAILING_PUNCTUATION_RE = /[.,;:!?)\]'"…*”’]+$/;

// Parte el cuerpo en tramos de texto y links a la ayuda, en orden.
export function splitHelpLinks(body) {
    const parts = [];
    let last = 0;
    for (const match of (body || '').matchAll(HELP_LINK_RE)) {
        const url = match[0].replace(TRAILING_PUNCTUATION_RE, '');
        const start = match.index;
        if (start > last) {
            parts.push({type: 'text', value: body.slice(last, start)});
        }
        parts.push({type: 'link', url});
        last = start + url.length;
    }
    if (last < (body || '').length) {
        parts.push({type: 'text', value: body.slice(last)});
    }
    return parts;
}

function onHelpLinkClick(event) {
    attributeHelpCenterClick(event, SUPPORT_CHAT_SOURCE);
}

export function SupportMessageText({body}) {
    const parts = splitHelpLinks(body);
    const hasLinks = parts.some((part) => part.type === 'link');

    // El token de quién abre el link se pide antes del clic: el clic no puede esperarlo.
    useEffect(() => {
        if (hasLinks) {
            prefetchHelpCenterIdentity();
        }
    }, [hasLinks]);

    return (
        <span className="support-chat-msg__text">
            {parts.map((part, index) => (part.type === 'link' ? (
                <a
                    key={index}
                    href={part.url}
                    data-help-url={part.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onMouseDown={onHelpLinkClick}
                    onClick={onHelpLinkClick}
                >
                    {part.url}
                </a>
            ) : (
                <Fragment key={index}>{part.value}</Fragment>
            )))}
        </span>
    );
}
